import Vue from 'vue'
import Router from 'vue-router'
import Upload from '@/components/Upload'
import Login from '@/components/Login'
import FileList from '@/components/FileList'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'FileList',
            component: FileList
        },
        {
            path: '/upload',
            name: 'Upload',
            component: Upload
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js